// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","MenuItem":"bge_a bhj_un bhj_cw bhj_a","MenuItem__Btn":"bge_b bhj_z"};